import ClientUnitItem from '../Domain/ClientUnitItem.js';
import AuthService from './authService.js';
import SearchParams from '../Elements/SearchParams';
import LocationsAdminSearchParams from '../Contents/Operations/Locations/LocationsAdminSearchParams';

class ClientUnitService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, LocationsAdminSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/ClientUnit/GetAllBySearchingAsync/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetClientUnitNameById(id) {
    let authService = AuthService.getInstance();
    let url = '/api/ClientUnit/GetNameById/' + id + '?clearCache=false';
    return authService.CallBackendFunction(url);
  }

  static GetClientUnitCountryNameById(id) {
    let authService = AuthService.getInstance();
    let url = '/api/ClientUnit/GetClientUnitCountryNameById/' + id + '?clearCache=false';
    return authService.CallBackendFunction(url);
  }

  static GetClientUnitClientNameById(id) {
    let authService = AuthService.getInstance();
    let url = '/api/ClientUnit/GetClientUnitClientNameById/' + id + '?clearCache=false';
    return authService.CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    let mappedItems = [];

    if (itemlist !== null) {
      mappedItems = itemlist.map((item) => new ClientUnitItem(item));
    }

    return mappedItems;
  }
}

export default ClientUnitService;
